// ─── Fase 17B · Bloque 2 — Imperative trigger for the GuideDrawer ──────
// Lightweight pub/sub via `window` CustomEvent to keep the drawer state in
// `GuideDrawer.jsx` (mounted once in App.js) while allowing any deeply
// nested component to open it without prop drilling or a context.

const EVT_OPEN = "pf:guide-drawer-open";

export function openGuideDrawer() {
  try { window.dispatchEvent(new CustomEvent(EVT_OPEN)); } catch { /* noop */ }
}

export function subscribeGuideDrawer(handler) {
  window.addEventListener(EVT_OPEN, handler);
  return () => window.removeEventListener(EVT_OPEN, handler);
}
